import { render, staticRenderFns } from "./fbrecaptcha.vue?vue&type=template&id=fc35e668&"
import script from "./fbrecaptcha.vue?vue&type=script&lang=js&"
export * from "./fbrecaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports